import { routeHref } from '../../lib/router.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- tpl-compose ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    container: { type: String, required: true },
    mailbox: String,
    draft: String,
    to: String,
    subject: String,
    body: String,
  }

  init() {
    this.state.loading = true
    this.state.error = ''
    this.state.container = null
    this.state.compose = null
    this.state.seq = 0
  }

  onRefresh(props, changed) {
    if (['container', 'mailbox', 'draft', 'to', 'subject', 'body'].some((key) => key in changed)) this.load()
  }

  async load() {
    const { container, draft } = this.props
    this.state.error = ''
    try {
      const [usable, saved] = await Promise.all([
        window.App.api(`container/${container}/my_mailboxes`, {}, { silent: true }),
        draft ? window.App.api(`container/${container}/draft`, { draft }, { silent: true }) : null,
      ])
      this.state.container = usable
      const fields = saved
        ? {
            mailbox: saved.mailbox,
            domain: saved.domain || undefined,
            from_local: saved.from_local || undefined,
            bcc: saved.bcc,
            to: saved.to,
            cc: saved.cc,
            subject: saved.subject,
            body: saved.body,
            in_reply_to: saved.in_reply_to || undefined,
            draft: saved.ref,
            attachments: saved.attachments,
          }
        : { mailbox: this.props.mailbox, to: this.props.to, subject: this.props.subject, body: this.props.body }
      this.state.compose = {
        ...fields,
        mailboxes: usable.mailboxes,
        domains: usable.domains.map((name) => ({ name })),
      }
      this.state.seq++
    } catch (error) {
      this.state.error = error.message
    } finally {
      this.state.loading = false
    }
  }

  back() {
    window.location.hash = this.state.backHref
  }

  beforeRender() {
    const { container, mailbox } = this.props
    this.state.backHref = routeHref('inbox', { container, mailbox })
    this.state.title = this.props.draft ? 'Draft' : 'New message'
  }

  CSS = `:fez {
display:block;.page{padding:var(--space-6) var(--space-6) var(--space-12)}.crumb{color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}.head{display:flex;align-items:center;gap:var(--space-4);margin:var(--space-4) 0 var(--space-6)}h1{font-size:var(--text-2xl);letter-spacing:-0.02em}.compose-card{max-width:880px} :mobile {.page{padding:var(--space-4) var(--space-4) var(--space-10)}}
}`

  HTML = `<div class="page">
{#if state.error}
<ui-empty icon="warning-circle" title="Could not open the message" text={state.error}></ui-empty>
{:else if state.compose}
<div class="crumb"><a href={state.backHref}>Mail</a></div>
<div class="head">
<ui-icon name="pencil-simple" size="34"></ui-icon>
<h1>{state.title}</h1>
</div>
<div class="ui-card pad-lg compose-card" fez:keep="compose-{state.seq}">
<mail-compose container={props.container} :mailbox="state.compose.mailbox" :domain="state.compose.domain" :from_local="state.compose.from_local" :bcc="state.compose.bcc" :mailboxes="state.compose.mailboxes" :domains="state.compose.domains" :to="state.compose.to" :cc="state.compose.cc" :subject="state.compose.subject" :body="state.compose.body" :in_reply_to="state.compose.in_reply_to" :draft="state.compose.draft" :attachments="state.compose.attachments" autofocus :on_done="(done) => fez.back()"></mail-compose>
</div>
{/if}
</div>`
};
}

Fez('tpl-compose', __fez_component_0);

export default __fez_component_0;
